(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('SearchController', SearchController);

    SearchController.$inject = ['$state', 'Principal'];

    function SearchController($state, Principal) {
        var vm = this;
        vm.phrase = $state.params.phrase;

        vm.isAuthenticated = Principal.isAuthenticated;
    }
})();